import type { TOC } from '@ember/component/template-only';

import type { CustomEmberTableColumn } from '../../../../types/components/prism/table.ts';

interface PrismTableHeadersThSublabelSignature {
  Args: {
    column: CustomEmberTableColumn;
  };
}

const PrismTableHeadersThSublabel = <template>
  <p>{{@column.name}}</p>
  {{#if @column.subLabel}}
    <p>{{@column.subLabel}}</p>
  {{/if}}
</template> satisfies TOC<PrismTableHeadersThSublabelSignature>;

export default PrismTableHeadersThSublabel;
